var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 8.28194V7.0604C15 4.25002 12.7857 1.9718 10.0541 1.9718H3.93773V0L0 4.05137L3.83236 7.99433V5.74577H9.99525C11.5349 5.74577 12.9478 6.62325 13.6646 8.02494L13.9345 8.55265C14.0321 8.74364 14.2246 8.86321 14.4344 8.86321C14.7465 8.86321 14.9994 8.60302 14.9994 8.28194H15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.71805V10.9396C0 13.75 2.21431 16.0282 4.94587 16.0282H11.0623V18L15 13.9486L11.1676 10.0057V12.2542H5.00475C3.46511 12.2542 2.05223 11.3767 1.33541 9.97505L1.06547 9.44735C0.967852 9.25635 0.775397 9.13678 0.565587 9.13678C0.253507 9.13678 0.000619822 9.39697 0.000619822 9.71805H0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.0c62c08cbca5a624a673cae311fa4ffa.svg";
export { ForwardRef as ReactComponent };